module.exports = __webpack_public_path__ + "media/images/logo-light-fd1eb35bde7714dd2f6969cf11a17363.png";